import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormTextField } from '@eas/common-web';
import { AddressFields } from '@composite/address/address-fields';

export function LocationFields() {
  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__WORK_ORDERS__DETAIL__PANEL__LOCATION_ADDRESS"
            defaultMessage="Adresa pracovného príkazu"
          />
        }
      >
        <AddressFields addressKey="address" disabled showCustomerNameField />
      </FormPanel>

      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__WORK_ORDERS__DETAIL__PANEL__LOCATION_CUSTOMER_ADDRESS"
            defaultMessage="Adresa zákazníka"
          />
        }
      >
        <AddressFields
          addressKey="customerAddress"
          disabled
          showCustomerNameField
        />
      </FormPanel>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__WORK_ORDERS__DETAIL__PANEL__LOCATION_MAILING_ADDRESS"
            defaultMessage="Korešpondenčná adresa"
          />
        }
      >
        <AddressFields
          addressKey="mailingAddress"
          disabled
          showCustomerNameField
        />
      </FormPanel>

      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__WORK_ORDERS__DETAIL__PANEL__LOCATION_COORDINATES"
            defaultMessage="Súradnice pracovného príkazu"
          />
        }
      >
        <FormTextField
          name="latitude"
          label={
            <FormattedMessage
              id="ZSD__WORK_ORDERS__DETAIL__FIELD_LABEL__LATITUDE"
              defaultMessage="Zemepisná šírka"
            />
          }
          disabled
        />
        <FormTextField
          name="longitude"
          label={
            <FormattedMessage
              id="ZSD__WORK_ORDERS__DETAIL__FIELD_LABEL__LONGITUDE"
              defaultMessage="Zemepisná dĺžka"
            />
          }
          disabled
        />
      </FormPanel>
    </>
  );
}
